import { useGetJobByIdQuery } from "~/shared/api/govDash/govDash.api";
import { canShareReport } from "~/features/share-report/model/share-report";
import { ShareReportDialog } from "~/features/share-report/ui/share-report.dialog";

/**
 * The waste-export record header's «Поделиться» icon, shown only for completed
 * jobs, the ones with a report worth sending. It reads the same job query as
 * WasteExportDetails, so it costs no extra request.
 */
export const WasteExportShareButton = ({ jobId }: { jobId: string }) => {
  const { data: job } = useGetJobByIdQuery({ id: BigInt(jobId) });

  if (!job || !canShareReport(job)) return null;
  return <ShareReportDialog job={job} />;
};
